@if (config()) {
  <app-advanced-search
    [config]="config()"
    [initialSearch]="initialSearch()"
    (searchChanged)="searchChanged.emit($event)"
  ></app-advanced-search>
}
